@if (header && contentSeo && !routeChanging) {
    <ds-card
        class="context-box-container"
        msThemedCard
        [themeCardElevated]="themeCardElevated"
        [themeBorder]="themeCardBorder"
        [radius]="isEpcotEnabled && !isMobileMode"
        [elevated]="true"
        [border]="true">
        <ds-accordion
            size="large"
            variant="surface-lowest"
            msThemedAccordion
            [themedAccordionVariant]="themedAccordionVariant"
            [withCard]="true"
            [open]="!collapsed"
            (openedChange)="toggle()">
            <ds-accordion-header class="content-box-header">
                <div slot="start">
                    <div slot="title">
                        @if (primaryHeader) {
                            <h1 class="header-title">{{ header }}</h1>
                        } @else {
                            <h2 class="header-title">{{ header }}</h2>
                        }
                    </div>
                </div>
            </ds-accordion-header>

            <ng-template #content>
                <ng-container>
                    <ds-divider />
                    <div class="content-box">
                        <div class="content" [innerHtml]="contentSeo"></div>
                    </div>
                </ng-container>
            </ng-template>
        </ds-accordion>
    </ds-card>
}
